import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ComicDetail from '@/components/disposable/ComicDetail.vue';
import { ComicType } from '@/model/comic';

export default /*#__PURE__*/_defineComponent({
  __name: 'ManhwaDetailView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComicDetail, {
    type: _unref(ComicType).Manhwa
  }, null, 8, ["type"]))
}
}

})